import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import messages from '../../../../../../text/messages';
import { getTimesheets, getAdminTimesheets, findTimesheets, approveTimesheet, getTimesheetShifts } from '../../../../../../reducers/timekeeping';
import { getViceVersaFullName } from '../../../../../../utilities/string';
import { getAdminDetails } from '../../../../../../reducers/users';
import Table from '../../../../../../components/table';
import TimesheetActionsDialog from './../../../../dialogs/timesheetActions';
import { TIMESHEET_STATUS } from '../../../../../../text/enumerations';
import { RoleDefinitions } from '../../../../../../utilities/roles';
import SearchBar from '../../../../../../components/searchBar';
import { nameSort, hmSort, periodSort } from '../../_common';
import { sortNamePeriodAsc, sortNamePeriodDsc, sortPeriodNameAsc, sortPeriodNameDsc, sortMinutes, renderPeriodEnding, renderHours } from '../../_common';

class ClientTimesheetsList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            searchString: ''
        };

        this.initialize = this.initialize.bind(this);
        this.getColumnDefinition = this.getColumnDefinition.bind(this);
        this.filterResults = this.filterResults.bind(this);
    }

    initialize() {
        const { role, details, filter, getAdminDetails, getTimesheets } = this.props;
        getAdminDetails(details.admin_id, () => {
            let statusFilterObject = {};
            let status = undefined;
            if (filter) {
                if (typeof filter === 'string') {
                    statusFilterObject = { status: filter };
                    status = filter;
                } else if (Array.isArray(filter) && filter.length > 0) {
                    status = filter[0];
                    statusFilterObject = { status: filter };
                } else {
                    status = undefined;
                }
            }
            getTimesheets(role.id, statusFilterObject, undefined, undefined, status);
        });
    }

    componentDidMount() {
        this.initialize();
    }

    getColumnDefinition() {
        const { workers, approveTimesheet, getTimesheetShifts, stringFilter } = this.props;
        let getWorker = job_id => workers.find(w => w.id === job_id);

        const renderColumn = timesheet => dom => (
            <TimesheetActionsDialog
                key={timesheet.id}
                job={workers.find(w => w.id === timesheet.job_id)}
                timesheet={timesheet}
                component={dom}
                reloadData={() => getTimesheetShifts(timesheet.id)}
            />
        );

        return [
            {
                label: <FormattedMessage {...messages.periodEnding} />,
                valueMap: d => renderColumn(d)(action => renderPeriodEnding(action, d, getWorker(d.job_id))),
                size: 'col-md-2 hidden-sm hidden-xs',
                sort: sortPeriodNameAsc,
                descSort: sortPeriodNameDsc
            },
            {
                label: <FormattedMessage {...messages.name} />,
                valueMap: d =>
                    renderColumn(d)(action => {
                        const worker = getWorker(d.job_id);
                        return (
                            <div className="row name-column clickable" onClick={action}>
                                <div className="col-xs-12">
                                    <div className="row">
                                        <div className="col-xs-12 name-cell ellipsis right-zero">{getViceVersaFullName(worker.user)}</div>
                                        <div className="col-xs-12 email-cell ellipsis right-zero">{worker.user.email}</div>
                                    </div>
                                </div>
                            </div>
                        );
                    }),
                size: 'col-sm-5 col-md-3 col-xs-8',
                sort: sortNamePeriodAsc,
                descSort: sortNamePeriodDsc
            },
            {
                label: <FormattedMessage {...messages.manager} />,
                valueMap: d =>
                    renderColumn(d)(action => (
                        <div className="row name-column clickable" onClick={action}>
                            <div className="col-xs-12">
                                <div className="row">
                                    <div className="col-xs-12 name-cell ellipsis right-zero">
                                        {d.job && d.job.hm ? getViceVersaFullName(d.job.hm) : <FormattedMessage {...messages.notProvided} />}
                                    </div>
                                    <div className="col-xs-12 email-cell ellipsis right-zero">
                                        {d.job && d.job.hm && d.job.hm.email ? d.job.hm.email : <FormattedMessage {...messages.notProvided} />}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )),
                size: stringFilter === TIMESHEET_STATUS.SUBMITTED ? 'col-sm-3 hidden-xs' : 'col-sm-4 hidden-xs',
                sort: (a, b) => hmSort(a, b) || periodSort(a, b) || nameSort(a, b),
                descSort: (a, b) => hmSort(b, a) || periodSort(a, b) || nameSort(a, b)
            },
            {
                label: <FormattedMessage {...messages.hours} />,
                valueMap: d => renderColumn(d)(action => renderHours(action, d.minutes, d.expense_total, d.deliverable_total)),
                size: 'col-md-2 col-sm-2 col-xs-4 text-right',
                sort: sortMinutes
            },
            {
                valueMap: d => {
                    if ([TIMESHEET_STATUS.SUBMITTED, TIMESHEET_STATUS.RESUBMITTED].includes(d.status)) {
                        return (
                            <div className="full-height-cell">
                                <div className="approve-button" onClick={() => approveTimesheet(d.id, '', this.initialize)}>
                                    <FormattedMessage {...messages.approve} />
                                </div>
                            </div>
                        );
                    }
                },
                size: 'col-sm-2 col-lg-1 hidden-xs text-right'
            }
        ];
    }

    filterResults() {
        const { timesheets } = this.props;
        const { searchString } = this.state;

        if (!searchString.trim()) {
            return timesheets;
        }

        let filter = searchString.toLowerCase();
        return timesheets.filter(
            e =>
                e.job.user.email.toLowerCase().includes(filter) ||
                getViceVersaFullName(e.job.user)
                    .toLowerCase()
                    .includes(filter) ||
                e.job.hm.email.toLowerCase().includes(filter) ||
                getViceVersaFullName(e.job.hm)
                    .toLowerCase()
                    .includes(filter)
        );
    }

    render() {
        const { timesheets } = this.props;
        if (!timesheets) return null;
        if (timesheets.length === 0) {
            return (
                <div className="col-xs-12 timesheet-list">
                    <div className="empty-list">
                        <FormattedMessage {...messages.noTimesheetsFound} />
                    </div>
                </div>
            );
        }

        return (
            <div className="row">
                <div className="col-sm-6 col-xs-12">
                    <SearchBar onSubmit={d => this.setState({ ...this.state, searchString: d.value })} />
                </div>
                <div className="col-xs-12">
                    <Table data={this.filterResults()} columns={this.getColumnDefinition()} defaultSortColumn={0} />
                </div>
            </div>
        );
    }
}

ClientTimesheetsList.defaultProps = {
    job: undefined,
    workers: undefined,
    filter: 'all'
};
ClientTimesheetsList.defaultProps = {
    job: PropTypes.object,
    workers: PropTypes.array
};

const mapStateToProps = (state, props) => {
    const role = state.identity.role;
    const profile = state.identity.profile;
    const eligibleJobs = props.workers.filter(w => w.hm_id === profile.id).map(w => w.id);
    const filter = Array.isArray(props.filter) && props.filter.length > 0 ? props.filter[0] : typeof props.filter === 'string' ? props.filter : 'all';
    const allTimesheets = state.timekeeping.timesheets[filter] || [];
    const timesheets = role.role === RoleDefinitions.ClientHiringManager.type ? allTimesheets.filter(t => eligibleJobs.includes(t.job_id)) : allTimesheets;

    return {
        role,
        details: state.identity.details,
        admin: state.users.adminDetails,
        stringFilter: filter,
        timesheets
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getAdminDetails,
            findTimesheets,
            getTimesheets,
            getAdminTimesheets,
            getTimesheetShifts,
            approveTimesheet
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ClientTimesheetsList);



// WEBPACK FOOTER //
// ./src/pages/timekeeping/lists/timesheets/tenants/client/index.jsx